import LabelValueField from './LabelValueField';

export default LabelValueField;
